














































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Segment from '@/engine/models/segment'
import GameState from '@/engine/models/game-state'
import Segments from '@/engine/common/segments'
import States from '@/engine/common/states'

@Component
export default class DartBoard extends Vue {
  @Prop({ type: Boolean, default: false })
  private disabled!: boolean

  private BRAUN_DUNKEL: string = 'rgba(202, 181, 149, 1)'
  private BRAUN_HELL: string = 'rgba(202, 181, 149, .4)'

  @Prop()
  private state!: GameState

  private readonly lightShotColor: string = 'rgba(74, 42, 67, .3)'
  private readonly darkShotColor: string = 'rgba(74, 42, 67, .5)'
  private readonly bullseyeShotColor: string = 'rgba(234, 102, 81, 1)' // Hellrot
  private readonly bullShotColor: string = 'rgba(246, 216, 77, 1)' // Hellgelb
  private readonly bullseyeActiveColor: string = 'rgba(112, 235, 250, 1)' // Hellblau
  private readonly bullShotActiveColor: string = 'rgba(0, 180, 255, 1)' // Dunkelblau
  private readonly bullseyePFR: string = 'rgba(246, 216, 77, .8)' // Hellgelb
  private readonly bullPFR: string = 'rgba(216, 184, 25, .8)' // Dunkelgelb

  private readonly buildingColor: string = '#F6D82C'
  private readonly borderColor: string = '#FFFFFF4D'

  private readonly DARK = 'dark'
  private readonly LIGHT = 'light'

  private readonly colors: { [id: string]: 'dark' | 'light' } = {
    e00: this.LIGHT,
    b00: this.DARK,
    l01: this.DARK,
    t01: this.LIGHT,
    u01: this.DARK,
    d01: this.LIGHT,
    l02: this.LIGHT,
    t02: this.DARK,
    u02: this.LIGHT,
    d02: this.DARK,
    l03: this.LIGHT,
    t03: this.DARK,
    u03: this.LIGHT,
    d03: this.DARK,
    l04: this.DARK,
    t04: this.LIGHT,
    u04: this.DARK,
    d04: this.LIGHT,
    l05: this.DARK,
    t05: this.LIGHT,
    u05: this.DARK,
    d05: this.LIGHT,
    l06: this.DARK,
    t06: this.LIGHT,
    u06: this.DARK,
    d06: this.LIGHT,
    l07: this.LIGHT,
    t07: this.DARK,
    u07: this.LIGHT,
    d07: this.DARK,
    l08: this.LIGHT,
    t08: this.DARK,
    u08: this.LIGHT,
    d08: this.DARK,
    l09: this.DARK,
    t09: this.LIGHT,
    u09: this.DARK,
    d09: this.LIGHT,
    l10: this.LIGHT,
    t10: this.DARK,
    u10: this.LIGHT,
    d10: this.DARK,
    l11: this.DARK,
    t11: this.LIGHT,
    u11: this.DARK,
    d11: this.LIGHT,
    l12: this.LIGHT,
    t12: this.DARK,
    u12: this.LIGHT,
    d12: this.DARK,
    l13: this.LIGHT,
    t13: this.DARK,
    u13: this.LIGHT,
    d13: this.DARK,
    l14: this.LIGHT,
    t14: this.DARK,
    u14: this.LIGHT,
    d14: this.DARK,
    l15: this.DARK,
    t15: this.LIGHT,
    u15: this.DARK,
    d15: this.LIGHT,
    l16: this.DARK,
    t16: this.LIGHT,
    u16: this.DARK,
    d16: this.LIGHT,
    l17: this.DARK,
    t17: this.LIGHT,
    u17: this.DARK,
    d17: this.LIGHT,
    l18: this.LIGHT,
    t18: this.DARK,
    u18: this.LIGHT,
    d18: this.DARK,
    l19: this.DARK,
    t19: this.LIGHT,
    u19: this.DARK,
    d19: this.LIGHT,
    l20: this.LIGHT,
    t20: this.DARK,
    u20: this.LIGHT,
    d20: this.DARK,
  }

  get segments(): Segment[] {
    return this.state.segments
  }

  public resetSegmentsHit() {
    this.forAllSegments(this.setInitialFill)

    if (this.state.gameplay.enabledTopToBottom) {
      this.forAllSegments(this.disableHighlight)
      if (States.countriesLeftToConquer(this.state)) {
        const topRegion = Segments.findTopFreeRegion(this.state)
        if (topRegion) {
          this.forRegion(parseInt(topRegion, 10), this.enableHighlight)
        }
      }
    }

    if (this.state.gameplay.enabledBullForLand) {
      this.disableHighlight('b00')
      const notAllConquered = States.countriesLeftToConquer(this.state)
      const bullNotHit = this.state.hasNotHit('b00')
      const bullseyeNotHit = this.state.hasNotHit('e00')
      if (notAllConquered && bullNotHit && bullseyeNotHit) {
        this.enableHighlight('b00')
        // Wenn PFR aktiviert undnoch kein Pol getroffen,
        // zeige Pols in Gelb.
        // Bei Easy Nordpol wird Bullseye weiterhin in 
        // Hellblau angezeigt.
        if (!this.state.bullsEyeEnabled) {
          this.setFill('e00', this.bullseyePFR)
        }
        // Bei Easy Südpol wird Bull weiterhin in
        // DUnkelblau angezeigt.
        if (!this.state.bullEnabled) {
          this.setFill('b00', this.bullPFR)
        }
      }
    }

    this.setOwnedColors()
    this.setShotColors()
  }

  @Watch('state', { deep: true })
  private stateChanged(val: GameState, oldVal: GameState) {
    this.resetSegmentsHit()
  }

  private setInitialFill(id: string) {
    switch (id) {
      case 'e00':
        this.setFill(
          id,
          this.state.bullsEyeEnabled
            ? this.bullseyeActiveColor
            : this.BRAUN_HELL,
        )
        break
      case 'b00':
        this.setFill(
          id,
          this.state.bullEnabled
            ? this.bullShotActiveColor
            : this.BRAUN_DUNKEL,
        )
        break
      default:
        switch (this.colors[id]) {
          case this.LIGHT:
            this.setFill(id, this.BRAUN_HELL)
            break
          case this.DARK:
            this.setFill(id, this.BRAUN_DUNKEL)
            break
        }
        break
    }
  }

  private enableHighlight(id: string) {
    const elem: HTMLElement | null = this.$el.querySelector(`#${id}`)
    if (elem) {
      switch (this.colors[id]) {
        case this.LIGHT:
          elem.classList.add('highlighted-light')
          break
        case this.DARK:
          elem.classList.add('highlighted-dark')
          break
      }
    }
  }

  private disableHighlight(id: string) {
    const elem: HTMLElement | null = this.$el.querySelector(`#${id}`)
    if (elem) {
      switch (this.colors[id]) {
        case this.LIGHT:
          elem.classList.remove('highlighted-light')
          break
        case this.DARK:
          elem.classList.remove('highlighted-dark')
          break
      }
    }
  }

  private setShotColors() {
    for (const shot of this.state.history) {
      this.disableHighlight(shot)
      switch (shot) {
        case 'e00':
          this.setFill(shot, this.bullseyeShotColor)
          break
        case 'b00':
          this.setFill(shot, this.bullShotColor)
          break
        default:
          switch (this.colors[shot]) {
            case this.LIGHT:
              this.setFill(shot, this.lightShotColor)
              break
            case this.DARK:
              this.setFill(shot, this.darkShotColor)
              break
          }
          break
      }
    }
  }

  private setOwnedColors() {
    for (const seg of this.segments) {
      if (this.state.gameplay.enabledConquerAll) {
        if (seg.owner) {
          this.setFill(seg.id, seg.owner.color)
          this.setBorder(seg.id, this.borderColor)
        }
      } else if (seg.alph === 'd' && seg.houses > 0) {
        this.setFill(seg.id, this.buildingColor + '66')
        this.setBorder(seg.id, this.borderColor)
      } else if (seg.alph === 't' && seg.villas > 0) {
        this.setFill(seg.id, this.buildingColor + '66')
        this.setBorder(seg.id, this.borderColor)
      } else if (seg.owner) {
        this.setSegmentAlphaFill(seg, seg.owner.color, '99', 'ff')
        this.setBorder(seg.id, this.borderColor)
      }
    }
  }

  private setBorder(id: string, color: string) {
    const elem: HTMLElement | null = this.$el.querySelector(`#${id}`)
    if (elem) {
      elem.style.strokeWidth = '1'
      elem.style.stroke = color
    }
  }

  private setSegmentAlphaFill(
    seg: Segment,
    color: string,
    lightAlpha: string,
    darkAlpha: string,
  ) {
    if (seg.alph === 'd' || seg.alph === 't') {
      this.setFill(seg.id, color + lightAlpha)
    } else {
      this.setFill(seg.id, color + darkAlpha)
    }
  }

  private setFill(id: string, color: string) {
    const elem: HTMLElement | null = this.$el.querySelector(`#${id}`)
    if (elem) {
      elem.style.fill = color
    }
  }

  private addClickEvent(id: string) {
    const elem: HTMLElement | null = this.$el.querySelector(`#${id}`)
    if (elem) {
      elem.addEventListener('click', (e) => {
        if (!this.disabled) {
          e.stopPropagation()
          const target = e.currentTarget as SVGSVGElement
          this.$emit('click', target, id)
        }
      })
    }
  }

  private forAllSegments(action: (id: string) => any) {
    action('b00')
    action('e00')
    for (let i = 1; i <= 20; i++) {
      this.forRegion(i, action)
    }
  }

  private forRegion(i: number, action: (id: string) => any) {
    const id = `${i}`.padStart(2, '0')
    action(`l${id}`)
    action(`t${id}`)
    action(`u${id}`)
    action(`d${id}`)
  }

  private mounted() {
    this.forAllSegments(this.addClickEvent)
    this.resetSegmentsHit()
  }
}
